// Shared React Query v4 cache policies. All finite durations are in milliseconds.
export const QUERY_CACHE_CONFIG = {
  COMPANY: {
    staleTime: 30 * 60 * 1000, // 30 phút
    cacheTime: 60 * 60 * 1000, // 1 giờ
  },
  REFERENCE_DATA: {
    staleTime: 24 * 60 * 60 * 1000, // 24 giờ
    cacheTime: 24 * 60 * 60 * 1000, // 24 giờ
  },
  // Keep the default cacheTime; Infinity only disables time-based staleness.
  UNTIL_INVALIDATED: {
    staleTime: Infinity, // Không tự stale theo thời gian; vẫn có thể invalidate/refetch
  },
} as const;
